var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('Header'),_c('h1',[_vm._v(" Page Not Found!")]),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("Go home?")])])],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }